import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productShopPanel',
    serviceName: 'grapghql',
    query: gql`
      query productShopPanel($ids: [String], $for_admin: Int) {
        productShopPanel(ids: $ids, for_admin: $for_admin) {
          data {
            product_info {
              id
              title
            }
          }
        }
      }
    `,
  },
};

export default schema;
